
export default callback => (firstLoad, propsMatch = true) => {
  if (firstLoad) {
    callback();
  }
  return { firstLoad: !propsMatch };
};
